// DESCRIBE : AI 이미지 생성 기능이 동작하지 않아 비활성화한 상태다. 기능이 복구되면 true로 되돌린다.
export const IS_AI_IMAGE_ENABLED = false;
